<header class="site-header" [class.site-header--transparent]="headerBg === '#F6F9FE'">
  <div class="header-inner" [class.site-header--transparent]="headerBg === '#F6F9FE'">
    <!-- Logo -->
    <a class="brand" href="/">
      <img src="./images/home/logoHeader.svg" alt="Studiflats" />
    </a>

    <!-- Desktop nav -->
    <nav class="main-nav">
      <a (click)="scrollToSection('services')">Services</a>
      <a (click)="scrollToSection('events')">Event Highlights</a>
      <a (click)="scrollToSection('plans')">Our Plans</a>
      <a routerLink="/about">About Us</a>
      <a routerLink="/contact">Contact Us</a>
    </nav>

    <!-- CTA (اختياري للديسكتوب) -->
    <a pButton class="cta desktop-cta" (click)="menu.toggle($event)">
      Download Our App <i class="pi pi-arrow-up-right"></i>
    </a>
    <!---------------------------------------------------------------------------------------------->
    <!-- p-menu popup -->
<p-menu #menu
        [popup]="true"
        [model]="qrMenuItems"
        [baseZIndex]="1100"
        [appendTo]="'body'"
        styleClass="qr-pmenu"
        [style]="{ width: 'min(420px, 92vw)' }">

  <!-- هيدر داخل المينيو: QR + عنوان + نص -->
  <ng-template pTemplate="start">
    <div class="qr-header">
      <div class="qr-img">
        <!-- صورة QR: إمّا ثابتة من assets أو DataURL مولّدة -->
        <img [src]="qrImg" alt="QR code to download Studiflats App" style="width: 100px; height: 100px;" />
      </div>
     
    </div>
    <!-- <hr class="qr-sep" /> -->
  </ng-template>

    
  <!-- (اختياري) تخصيص عنصر المينيو عشان شكله يبقى زر كبير -->
  <!-- <ng-template pTemplate="item" let-item>

      <div *ngIf="item.header"  class="qr-text">
        <div class="title">Scan to download Studiflats App</div>
        <div class="muted">Or get it here :</div>
      </div>
   
    <div class="btns">
        <a [href]="item.url || null"
       [attr.target]="item.target || null"
       class="store"
       (click)="item.command?.($event)">
      <img [src]="item.img"/>
    </a>
    </div>
  </ng-template> -->

   <ng-template pTemplate="item" let-item>
    <div class="grid-3">
         <!-- يظهر مرة واحدة لما item.header = true -->
    <ng-container *ngIf="item.header; else storeTpl">
      <div class="qr-text">
        <div class="title">Scan to download Studiflats App</div>
        <div class="muted">Or get it here :</div>
      </div>
    </ng-container>

    <!-- باقي العناصر (الأزرار) -->
    <ng-template #storeTpl>
      <a class="store"
         [href]="item.url || null"
         [attr.target]="item.target || null"
         (click)="item.command?.($event)">
        <img [src]="item.img" alt="{{item.label}}" />
      </a>
    </ng-template>
    </div>
  </ng-template>
   
</p-menu>
    <!----------------------------------------------------------------------------------------------->

    <!-- Mobile toggle -->
    <button *ngIf="!mobileOpen"  class="nav-toggle" aria-label="Open menu"
            [attr.aria-expanded]="mobileOpen" [class.site-header--transparent]="headerBg === '#F6F9FE'" (click)="openMobile()">
      <!-- <span class="hamb"></span><span class="hamb"></span><span class="hamb"></span> -->

      <img *ngIf="headerBg==='solid'" src="./images/home/toggleIcon.svg"/>
      <img *ngIf="headerBg==='#F6F9FE'"  src="./images/home/toggleIconWhite.svg"/>

    </button>
  </div>
</header>

<!-- Mobile Sheet -->
<div   class="mobile-menu" [class.open]="mobileOpen" (keydown.escape)="closeMobile()">
  <div class="backdrop" (click)="closeMobile()"></div>

  <aside class="sheet" role="dialog" aria-modal="true" [attr.aria-hidden]="!mobileOpen">
    <div class="sheet-head">
      <img src="./images/home/logoHeader.svg" alt="Studiflats" class="sheet-logo"/>
      <button class="close" aria-label="Close" (click)="closeMobile()">✕</button>
    </div>

    <hr class="divider" />

    <nav class="sheet-nav">
      <a (click)="scrollToSection('services');" (click)="closeMobile()">Services</a>
      <a (click)="scrollToSection('events');" (click)="closeMobile()">Event Highlights</a>
      <a (click)="scrollToSection('plans');" (click)="closeMobile()">Our Plans</a>
      <a routerLink="/about" (click)="closeMobile()">About Us</a>
      <a routerLink="/contact" (click)="closeMobile()">Contact Us</a>
    </nav>

    <a pButton class="cta wide"  (click)="menu.toggle($event)">
      Download Our App <i class="pi pi-arrow-up-right"></i>
    </a>
  </aside>
</div>
